const PreparePackageMode = {
    EAN_READ_EACH: 'EAN_READ_EACH',
    SELECT_EACH: 'SELECT_EACH',
    SELECT_FIRST_AUTO_PACK_REST: 'SELECT_FIRST_AUTO_PACK_REST'
};

export {PreparePackageMode};
